import { ResponsivePie } from '@nivo/pie'
import { linearGradientDef } from '@nivo/core'
import React from 'react'


export const CardRadialBar = ({ averageResponses = 0 }) => {

    const failAverage = Math.round(100 - averageResponses)
    return (
        <div className='w-full h-full relative'>
            <MyResponsiveRadialBar averageOk={averageResponses} averageFail={failAverage} />
            <div className='w-full h-[100px] 2xl:h-[140px] absolute top-0 flex flex-col justify-end items-center'>
                <p className='text-base text-black'> {Math.round(averageResponses)}%</p>
                <p className='text-sm text-black'> Porcentaje promedio</p>
            </div>
        </div>
    )
}

export default CardRadialBar

const MyResponsiveRadialBar = ({ averageOk = 0, averageFail = 0, data = [
    {
        "id": "averageOK",
        "label": "averageOK",
        "value": averageOk,
        "color": "hsl(24, 70%, 50%)"
    },
    {
        "id": "averageFail",
        "label": "averageFail",
        "value": averageFail,
        "color": "hsl(310, 70%, 50%)"
    },
] /* see data tab */ }) => (

    <ResponsivePie
        data={data}

        margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
        startAngle={-90}
        endAngle={90}
        innerRadius={0.9}
        padAngle={0.7}

        activeOuterRadiusOffset={8}
        // colors={{ scheme: 'category10' }}
        // colors={['#0047AB', '#ffffff']}
        defs={[
            // using helpers
            // will inherit colors from current element
            linearGradientDef('gradientA', [
                { offset: 0, color: '#6395F9' },
                { offset: 100, color: '#C6D8FB', opacity: 1 },
            ], {
                gradientTransform: 'rotate(90 0.5 0.5)'
            }),
            linearGradientDef('gradientB', [
                { offset: 0, color: '#F0F0F0' },
                { offset: 100, color: '#F0F0F0' },
            ],
                // you may specify transforms for your gradients, e.g. rotations and skews,
                // following the transform attribute format.
                // For instance here we rotate 90 degrees relative to the center of the object.
                {
                    gradientTransform: 'rotate(90 0.5 0.5)'
                }),
            // using plain object
            {
                id: 'gradientC',
                type: 'linearGradient',
                colors: [
                    { offset: 0, color: '#F0F0F0' },
                    { offset: 100, color: '#F0F0F0' },
                ],
            },
        ]}
        // 2. defining rules to apply those gradients
        fill={[
            // match using object query
            { match: { id: 'averageOK' }, id: 'gradientA' },
            // match using function
            { match: d => d.id === 'averageFail', id: 'gradientB' },
            // match all, will only affect 'elm', because once a rule match,
            // others are skipped, so now it acts as a fallback
            { match: '*', id: 'gradientC' },
        ]}

        colorBy="index"
        enableArcLinkLabels={false}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: 'color' }}
        enableArcLabels={false}
        arcLabelsSkipAngle={10}

        isInteractive={false}

    />
)